import config from "config/config";

const urls = {
    "notice-list" : "wizcommon/api/v2/notice/list",
    "notice-detail" : "wizcommon/api/v2/notice",
    "faq-list" : "wizcommon/api/v2/faq/list",
    "faq-detail" : "wizcommon/api/v2/faq",
    "qna-list" : "wizcommon/api/v2/qna/list",
    "qna-detail" : "wizcommon/api/v2/qna",
    "qna-send" : "wizcommon/api/v2/qna/send",
    "file-upload" : "wizcommon/api/v2/file/upload",
    
    //알림
    "notifications" : "wizmessage/api/v2/push/hist",

    //약관
    "terms-list"   : "wizcommon/api/v2/terms/active/",   // GET /{serviceId}?locale=
    "terms-detail" : "wizcommon/api/v2/terms/",          // GET /{termsId}
}

export const getApiUrl = (name: keyof typeof urls) => {
    return config.API_URL + "/" + urls[name];
}
